import {datadogLogs} from "@datadog/browser-logs";

export const initDatadog = () => {
    const cfg = window.appConfig?.datadog;
    if (!cfg?.logsClientToken) return;
    datadogLogs.init({
        clientToken: cfg.logsClientToken,
        site: cfg.site ?? undefined,
        service: cfg.service ?? undefined,
        env: cfg.env ?? undefined,
        version: cfg.version ?? undefined,
        forwardErrorsToLogs: true,
        sessionSampleRate: 100,
    });
};
